import { useCallback, useEffect, useRef } from 'react'
import { useComposerMentionSuggestions } from './useComposerMentionSuggestions.js'
import { runSyncMentionUi } from './syncMentionUi.js'

export function useComposerMentionsSync(editor, enableMentions, mentionMembers, mentionAgents, refs) {
  const refsRef = useRef(refs)
  refsRef.current = refs
  const { mentionTrigger, setMentionActiveIndex } = refs
  const { mentionUsers, mentionAgentsList, mentionFlatCount } = useComposerMentionSuggestions(
    mentionMembers,
    mentionAgents,
    mentionTrigger,
    refs.mentionFlatCountRef,
  )

  const syncMentionUi = useCallback(
    () => runSyncMentionUi(editor, enableMentions, refsRef.current),
    [editor, enableMentions],
  )

  useEffect(() => {
    setMentionActiveIndex(0)
  }, [mentionTrigger?.query, mentionUsers.length, mentionAgentsList.length, setMentionActiveIndex])

  useEffect(() => {
    if (mentionFlatCount === 0) return
    setMentionActiveIndex((i) => Math.min(i, mentionFlatCount - 1))
  }, [mentionFlatCount, setMentionActiveIndex])

  return { mentionUsers, mentionAgentsList, mentionFlatCount, syncMentionUi }
}
